/* eslint-disable import/first */

// Dynamic public path
// eslint-disable-next-line
__webpack_public_path__ = window.bawu.javascriptBase || '/javascripts/';

// Polyfills & shims
import '@babel/polyfill';
import 'focus-visible';
import 'whatwg-fetch';
import 'element-matches';
import 'element-closest';
import 'url-polyfill';
import './shims/element-remove';
import './shims/focus-within';
import './shims/nodelist-foreach';
import './shims/datepicker';
import './shims/popup';
import './shims/custom-event';

// Shared
import './utils/cookie-alert';
import './utils/anchor-scroll';
import './utils/print';
import './utils/chatbot';
import './utils/tracker';
import './utils/overlay';
import './utils/control-f';

// Watcher
import './watcher/bp-user-actions';
import './watcher/magic-matze-cart';

// Components
// import 'components/<atoms|molecule|organisms>/<component-name>/<js-file>';
import 'components/_particles/loading/loading';
import 'components/_particles/chatbot/chatbot';

// Atoms
import 'components/atoms/copyright/copyright';
import 'components/atoms/sticky-link/sticky-link';

// Molecules
import 'components/molecules/figure/figure';
import 'components/molecules/tab-bar/tab-bar';
import 'components/molecules/table/table';
import 'components/molecules/phase-timeline/phase-timeline';
import 'components/molecules/comment/comment';
import 'components/molecules/number-input/number-input';
import 'components/molecules/thumb-rating/thumb-rating';
import 'components/molecules/social-embed/social-embed';
import 'components/molecules/social-wall/social-wall';
import 'components/molecules/table/TableSorter';
import 'components/molecules/teaser/teaser';

// Organisms
import 'components/organisms/accordion/accordion';
import 'components/organisms/footer/footer';
import 'components/organisms/slider/slider';
import 'components/organisms/share-dialog/share-dialog';
import 'components/organisms/header/header';
import 'components/organisms/teaser-slider/teaser-slider';
import 'components/organisms/box/facebook/facebook';
import 'components/organisms/box/instagram/instagram';
import 'components/organisms/box/twitter/twitter';
import 'components/organisms/messages-slider/messages-slider';
import 'components/organisms/box/calendar/calendar';
import 'components/organisms/multibox/multibox';
import 'components/organisms/contact-flyout/contact-flyout';
import 'components/organisms/timeline/timeline';
import 'components/organisms/memory-game/memory-game';
import 'components/organisms/box/audio-player/audio-player';
import 'components/organisms/comment-list/comment-list';
import 'components/organisms/box/banner-quicklink/banner-quicklink';
import 'components/organisms/box/quote-box/quote-box';
import 'components/organisms/box/association/association';
import 'components/organisms/storytelling/storytelling';
import 'components/organisms/article/article-tools';
import 'components/organisms/link-slider/link-slider';
import 'components/organisms/topic-grid/topic-grid';
import 'components/organisms/list-fetch/list-fetch';
import 'components/organisms/topic-search/topic-search';
import 'components/organisms/glossary-list/glossary-list';
import 'components/organisms/list-container/list-container';
import 'components/organisms/map-interactive-states/map-interactive-states';
import 'components/organisms/map-interactive-states-teaser/map-interactive-states-teaser';
import 'components/organisms/mindmap/mindmap';
